import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ApiMethod } from "../apimethods/api-method";
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from "../common/customfunctions";
import { GlobalConstants } from "../common/global-constants";
import { ProjectPlanAPIModel } from "./project-plan-model";
declare var $;
@Component({
  selector: "app-project-plan",
  templateUrl: "./project-plan.component.html",
  styleUrls: ["./project-plan.component.css"]
})
/** ProjectPlan component*/
export class ProjectPlanComponent {
  /** ProjectPlan ctor */
  modelItem = new ProjectPlanAPIModel;

  @ViewChild("dataTable", { static: false }) table;

  showModal: boolean;
  title: string;

  articleNo: string;
  doi: string;
  receivedDate: string;
  dueDate: string;
  tatDetails: string;
  authors: string;
  popUpButtonText: string;

  dataTable: any;
  dataSet: any;
  daysList = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  monthNo = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ProjectPlanAPIModel>data["ProjectPlanning"];
        this.getProjectPlanList();
        localStorage.aEID = 0;
        localStorage.aSequence = 0;
        localStorage.nRevisedDate = 0;
        localStorage.nDays = 0;
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  getProjectPlanList() {
    $("#LoadingImage").show();
    var projectPlanData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.ProjectPlanAPI, projectPlanData).subscribe(
      result => {
        $("#LoadingImage").hide();

        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = "btn_AddNew";
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = "ProjectPlanModule";
        dataItem.isDefault = true;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        //this.dataTable = customfunctions.dynamicDataTable(acolList, 'btn_AddNew', this.dataTable, this.dataSet, (GlobalConstants.size.height - 150), 'ProjectPlanModule', "", true);
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  show() {
    $("#LoadingImage").show();
    ApiMethod.getMethod(this.modelItem.ProjectPlanDetailsAPI + '/' + localStorage.aEID).subscribe(
      response => {
        this.articleNo = response.articleInfo.ArticleNo;
        this.doi = response.articleInfo.DOI;
        this.receivedDate = this.dateFormat(response.articleInfo.ReceivedDate);
        this.dueDate = this.dateFormat(response.articleInfo.DueDate);
        this.tatDetails = this.diffWeeks(response.articleInfo.ReceivedDate, response.articleInfo.DueDate) + "- weeks";
        this.authors = response.articleInfo.Authors;
        var items = response.planningFlow;
        $("#tblProjectPlanInfo tbody").html("");
        var nRowL = "";
        var srNo = 0;
        var isPopulate = 1;
        for (var i = 0; i < items.length; i++) {
          var actDaty = items[i].Days;
          var ztrOverDue = "";
          if (isPopulate == 1) {
            var zDate = this.formatDateIe(this.formatDate(new Date()));
            var zRevisedtDate = this.formatDateIe(this.formatDateColumn(items[i].RevisedScheduleDate));
            var zComDate = this.formatDateIe(this.formatDateColumn(items[i].CompletedDate));

            if (zDate > zRevisedtDate && items[i].CompletedDate == null) {
              ztrOverDue = "background-color: #ffbfbf;";
            }
            else if (items[i].CompletedDate != null && zRevisedtDate == zComDate) {
              ztrOverDue = "background-color: #4dff8c;";
            }
            else if (items[i].CompletedDate != null && zRevisedtDate > zComDate) {
              ztrOverDue = "background-color: #fff38d;";
            }
            else if (items[i].CompletedDate != null && zRevisedtDate < zComDate) {
              ztrOverDue = "background-color: #ffbfbf;";
            }
          }
          if (actDaty < 0) {
            ngswal("Failed", "Invalid Buffer Days !", "warning");

            return false;
          }

          //Check Parallel Flow
          var isParalleFlow = (items[i].ParallelID == 1 || items[i].Percentage == 0);
          if (typeof items[i].ParallelID == "undefined" || items[i].ParallelID == null) {
            isParalleFlow = false;
          }
          if (isParalleFlow)
            nRowL += "<tr class='trParallelFlow' style='" + ztrOverDue + "' title='Parallel Flow' id='tr" + (i + 1).toString() + "'>";
          else
            nRowL += "<tr class='' style='" + ztrOverDue + "' id='tr" + (i + 1).toString() + "'>";
          srNo = i + 1;
          nRowL += "<td>" + srNo.toString() + "</td>";
          nRowL += "<td>" + items[i].Activity + "</td>";
          nRowL += "<td>" + items[i].ID + "</td>";
          if (items[i].CompletedDate == null) {
            if (isParalleFlow)
              nRowL += "<td width='10%' id='act_" + srNo.toString() + "'><input type='text' id='day_" + srNo.toString() + "' class='form-control IsNumeric' value='" + 0 + "' maxlength='3' onchange=localStorage.ActivityNo='" + srNo.toString() + "';$('#btnUpdateScheduleDate').trigger('click'); ></td>";
            else
              nRowL += "<td width='10%' id='act_" + srNo.toString() + "'><input type='text' id='day_" + srNo.toString() + "' class='form-control IsNumeric' value='" + actDaty + "' maxlength='3' onchange=localStorage.ActivityNo='" + srNo.toString() + "';$('#btnUpdateScheduleDate').trigger('click');></td>";
          }
          else
            nRowL += "<td>" + actDaty + "</td>";

          if (isParalleFlow) {
            nRowL += "<td>" + this.formatDateColumn(items[i - 1].ScheduleDate) + "</td>";
            nRowL += "<td>" + this.getDayName(this.formatDateColumn(items[i - 1].ScheduleDate)) + "</td>";
          }
          else {
            nRowL += "<td>" + this.formatDateColumn(items[i].ScheduleDate) + "</span></td>";
            nRowL += "<td>" + this.getDayName(this.formatDateColumn(items[i].ScheduleDate)) + "</td>";
          }

          if (isPopulate == 1) {
            nRowL += "<td>" + this.formatDateColumn(items[i].RevisedScheduleDate) + "</td>";

            if (items[i].CompletedDate != null) {
              /*nRowL += "<td>" + this.formatDateColumns(items[i].CompletedDate) + "</td>";*/
              nRowL += "<td><input type='Date' class='form-control txtCompletedDate' id='cDate_" + srNo.toString() + "' autocomplete='off' value='" + this.formatDateColumn(items[i].CompletedDate, 'yyyy') + "' onchange=localStorage.ActivityNo='" + srNo.toString() + "';$('#btnUpdateCompletedDate').trigger('click');></td>";
            }
            else {
              nRowL += "<td><input type='Date' class='form-control txtCompletedDate' id='cDate_" + srNo.toString() + "' autocomplete='off' value='" + this.formatDateColumn(items[i].CompletedDate, 'yyyy') + "' onchange=localStorage.ActivityNo='" + srNo.toString() + "';$('#btnUpdateCompletedDate').trigger('click');></td>";
            }
          }

          nRowL += "</tr>";
        }

        $("#tblProjectPlanInfo tbody").append(nRowL);

        $("input.IsNumeric").keydown(e => {
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) != -1 || (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
            return;
          }
          if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
          }
        });

        $("#LoadingImage").hide();
        this.showModal = true;
        this.title = "Project Planning Details";
        this.popUpButtonText = "Update";
        return true;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  updateScheduleDate() {
    var aRevisedDate;
    var aRowId = $("#act_" + localStorage.ActivityNo).closest("tr").find("td")[0].innerHTML;

    aRevisedDate = $("#act_" + localStorage.ActivityNo).closest("tr").find("td")[5].innerHTML; // Revised schedue Date
    if (aRevisedDate == "")
      aRevisedDate = $("#act_" + localStorage.ActivityNo).closest("tr").find("td")[3].innerHTML; // Schedule Date

    var days = $("#day_" + localStorage.ActivityNo).val();
    if (days >= 0)
      this.getRevisedDate(aRowId, aRevisedDate, days);
    else {
      ngswal("Warning", "Days value can not less than 0", "warning");
      $("#day_" + localStorage.ActivityNo).val("0");
    }
  }

  updateCompletedDate() {
    var cDate = $("#cDate_" + localStorage.ActivityNo);

    if (cDate.val() == "")
      return false;

    var aRowId = parseInt($("#act_" + localStorage.ActivityNo).closest("tr").find("td")[0].innerHTML);
    aRowId = aRowId - 2;
    var aitemL = $($("#tblProjectPlanInfo tbody tr")[aRowId]).find(".txtCompletedDate").val();

    if (aitemL == "") {
      cDate.val("");
      ngswal("Failed", "Previous activity still not Complete !", "warning");
      return false;
    }
    else {
      var zDate = this.formatDateIe(this.formatDateColumn(cDate.val()));
      var zPrevCmtDate = this.formatDateIe(this.formatDateColumn(aitemL));

      if (zPrevCmtDate > zDate) {
        ngswal("Failed", "Invalid Date Select ! ", "warning");
        cDate.val("");
        return false;
      }
    }

    aRowId = parseInt($("#act_" + localStorage.ActivityNo).closest("tr").find("td")[0].innerHTML);
    $("#act_" + localStorage.ActivityNo).closest("tr").find("#day_" + localStorage.ActivityNo).attr("disabled", "disabled");
    this.getRevisedDate(aRowId, cDate.val(), 0);
    return false;
  }

  updateProjectPlan() {
    let getActivityList = GlobalConstants.GetTableRowToList("tblProjectPlanInfo", null);

    if (getActivityList.length == 0) {
      ngswal("Failed", "Get Workflow Activities !", "error");

      return false;
    }

    var alasttr = $("#tblProjectPlanInfo").find("tr:nth-last-child(1) td");
    var aBookDueDate = this.formatDateIe(this.formatDateColumn(this.dueDate));
    var aFinalDueDate = this.formatDateIe(this.formatDateColumn(alasttr[3].innerText));

    if (new Date(aFinalDueDate) > new Date(aBookDueDate)) {
      ngswal("Failed", "Schedule Date should not be greater than Book Due date !", "warning");

      return false;
    }

    for (var i = 0; i < getActivityList.length; i++) {
      getActivityList[i] = getActivityList[i].toString();
    }

    var data = {
      Id: localStorage.aEID,
      UpdatedBy: localStorage.aLoginID,
      ActivityList: getActivityList,
      FlowId: localStorage.ID
    }
    $("#LoadingImagePopup").show();
    ApiMethod.postMethod(this.modelItem.UpdateProjectPlanningAPI, data).subscribe(
      response => {
        if (response.status) {
          $("#LoadingImagePopup").hide();
          this.hide();

          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.getProjectPlanList();
        } else {
          ngswal("Failed", "Please try again later !", "error");
        }
      }, error => {
        ngswal("Error", error.message, "error");
      }
    );
    return false;
  }

  getRevisedDate(nSequenceId, nRevisedDate, nDays) {
    if (nDays != 0) {
      localStorage.aSequence = nSequenceId;
      localStorage.nRevisedDate = nRevisedDate;
      localStorage.nDays = nDays;

      this.revisedScheduleUpdatedList();
    } else {
      ngswal({
        title: "Are you want to Revised the Schedule date?",
        text: "Revised schedule date will be update !",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, Update!",
        cancelButtonText: "No, Cancel!",
        closeOnConfirm: false,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            localStorage.aSequence = nSequenceId;
            localStorage.nRevisedDate = nRevisedDate;
            localStorage.nDays = nDays;

            $("#btnRevisedScheduleDate").trigger("click");

            ngswal({
              position: "top-end",
              type: "success",
              title: "Updated !",
              text: "Revised schedule dates updated !",
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Canceled !",
              text: "Revised schedule date update canceled",
              showConfirmButton: false,
              timer: 1500
            });
          }
        });
    }
  }

  revisedScheduleUpdatedList() {

    var data = {
      SequnceId: localStorage.aSequence,
      CompletedDt: localStorage.nRevisedDate,
      Id: localStorage.aEID,
      DaysP: localStorage.nDays,
      ReceivedDt: this.receivedDate
    }

    $("#LoadingImagePopup").show();
    ApiMethod.postMethod(this.modelItem.GetScheduleAPI, data).subscribe(
      response => {
        $("#LoadingImagePopup").hide();
        var items = JSON.parse(response);

        $.each(items, (index, itemVal) => {

          var revisedDate = this.getDate(itemVal.RevisedScheduleDate);

          $($('#tblProjectPlanInfo tbody tr[id="tr' + itemVal.SNo + '"]').find("td")[5]).html(revisedDate.dtT);
          $($('#tblProjectPlanInfo tbody tr[id="tr' + itemVal.SNo + '"]').find("td")[5]).attr("title", revisedDate.aDay);
        });

        var text = $($('#tblProjectPlanInfo tbody tr[id="tr' + localStorage.ActivityNo + '"]').find("td")[5]).html();
        if (text == "") {
          var cDate = $("#cDate_" + localStorage.ActivityNo).val();
          var revisedDate = this.getDate(cDate);

          $($('#tblProjectPlanInfo tbody tr[id="tr' + localStorage.ActivityNo + '"]').find("td")[5]).html(revisedDate.dtT);
          $($('#tblProjectPlanInfo tbody tr[id="tr' + localStorage.ActivityNo + '"]').find("td")[5]).attr("title", revisedDate.aDay);
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getDate(cDate) {
    var date = new Date(cDate);
    var day = date.getDate();
    var dayString = day > 9 ? day : '0' + day;
    var dateString = dayString + '-' + this.monthNames[date.getMonth()] + '-' + date.getFullYear();

    var obj = {
      dtT: dateString,
      aDay: this.daysList[new Date(dateString).getDay()]
    };

    return obj;
  }

  diffWeeks(dt2, dt1) {
    var diff = (new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7);

    return Math.abs(Math.round(diff));
  }

  getDayName(aDt) {
    try {
      if (aDt == "" || aDt == null)
        return "";
      var adate = new Date(aDt);
      var aval = this.daysList[adate.getDay()];
      return (typeof aval == "undefined" ? "" : aval);
    } catch (e) {
      return "";
    }
  }

  formatDateIe(dateL) {
    try {
      dateL = dateL.split("-");
      var zmonthL = this.monthNames.indexOf(dateL[1].toString()) + 1;

      var monthString = zmonthL > 9 ? zmonthL : '0' + zmonthL;
      var dtT = dateL[2].toString() + '-' + monthString + '-' + dateL[0].toString();
      return dtT;
    } catch (e) {
      return "";
    }
  }

  formatDateColumn(dateL, format = '') {
    try {
      if (dateL == "" || dateL == null)
        return "";

      var date = new Date(dateL);
      var day = date.getDate();
      //var day = new Date(date.setDate(date.getDate() + days)).getDate();

      var dayString = day > 9 ? day : '0' + day;
      var Monthstr = this.monthNo[date.getMonth()] > 9 ? this.monthNo[date.getMonth()] : '0' + this.monthNo[date.getMonth()];
      var dtT = dayString + '-' + Monthstr + '-' + date.getFullYear(); //month_names[date.getMonth()]
      if (format = 'yyyy') {
        dtT = date.getFullYear() + '-' + Monthstr + '-' + dayString;
      }

      return dtT;
    } catch (e) {
      return "";
    }
  }

  formatDate(dateL) {
    try {

      var date = new Date(dateL);

      var day = date.getDate();
      var dayString = day > 9 ? day : '0' + day;
      var dtT = dayString + '-' + this.monthNames[date.getMonth()] + '-' + date.getFullYear(); //month_names[date.getMonth()]

      return dtT;
    } catch (e) {
      return "";
    }
  }
 
  dateFormat(dateL) {
    var currentDate = "";

    if (dateL != null) {
      var date = new Date(dateL);
      var currentDay = ("0" + date.getDate()).slice(-2);
      var currentMonth = ("0" + (date.getMonth() + 1)).slice(-2);
      currentDate = date.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    }

    return currentDate;
  }

  hide() {
    this.showModal = false;
  }

  delete() {
    ngswal({
      title: this.modelItem.DeleteTitle,
      text: this.modelItem.DeleteText,
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  deleteConfirm() {
    $("#LoadingImage").show();

    var projectPlanData = {
      Id: localStorage.aEID,
      LoginId: localStorage.aLoginID
    }

    ApiMethod.postMethod(this.modelItem.DeleteProjectPlan, projectPlanData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Deleted !",
            text: result.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.getProjectPlanList();
        } else {
          ngswal("Failed !", this.modelItem.FailedMsg, "error");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
}
